import { Dialog, DialogContent, DialogTitle, Fade } from "@mui/material";

import "../../styles/signUpDialog.css";
import candidate from "../../images/candidate.png";
import employer from "../../images/employer.png";
import coach from "../../images/coach.png";
import { useState } from "react";
import RegisterModal from "./RegisterModal";
import CloseIcon from '@mui/icons-material/Close';
import Welcomecoachmodal from "../Welcomecoachmodal";
import SignUp from "./SignUp";
import LoginModal from "./LoginModal";

export default function SignUpAs({ addSignUpAsAction, setAddSignUpAsAction }) {
  const [addRegisterModalAction, setAddRegisterModalAction] = useState(false);
  const [addLoginAction, setAddLoginAction] = useState(false);
  const [addSignUpAction, setAddSignUpAction] = useState(false);
  const [open, setOpen] = useState(false);

  const closeHandler = (event, reason) => {
    if (reason && reason == "backdropClick")
      return;
    setAddSignUpAsAction(false);
  }
  const [employeeRole, setEmployeeRole] = useState('')
  const handleSelect = (role) => {
    setAddSignUpAsAction(false);
    setEmployeeRole(role)
    if(role == "COACH"){
      setOpen(true);
    }else{
      setAddSignUpAction(true);
    }
  }
  return (
    <>
      <Dialog
        open={addSignUpAsAction}
        TransitionComponent={Fade}
        transitionDuration={500}
        onClose={closeHandler}
        maxWidth="xs"
        fullWidth
        className="customDialog"
      >
        <DialogTitle>
          <CloseIcon sx={{ float: 'right', cursor: 'pointer' }} onClick={closeHandler} />
        </DialogTitle>
        <DialogContent>
          <div className="signUpModal">
            <div className="signUpModal-box">
              <div className="signUpModal-content">
                <div className="signUpModal-body">
                  <span className="signUpModal-span1">Join us to sign in!</span>
                  <div
                    className="signUpModal-div"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 3,
                    }}
                    onClick={() => handleSelect("EMPLOYER")}

                  >
                    <span>
                      <img src={employer} className="signUpModal-icon" alt="img" />
                    </span>
                    <span className="signUpModal-span2">Sign up as an Employer</span>
                  </div>
                  <div className="signUpModal-div2" style={{ position: "relative" }}>
                    <span className="signUpModal-span3">or</span>
                  </div>
                  <div
                    className="signUpModal-div"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 3,
                    }}
                    onClick={() => handleSelect("CANDIDATE")}

                  >
                    <span>
                      <img src={candidate} className="signUpModal-icon" alt="img" />
                    </span>
                    <span className="signUpModal-span2">Sign up as a Candidate</span>
                  </div>
                  <div className="signUpModal-div2" style={{ position: "relative" }}>
                    <span className="signUpModal-span3">or</span>
                  </div>
                  <div
                    className="signUpModal-div"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 3,
                    }}
                    onClick={() => handleSelect("COACH")}
                  >
                    <span>
                      <img src={coach} className="signUpModal-icon" alt="img" />
                    </span>
                    <span className="signUpModal-span2">Sign up as a Coach</span>
                  </div>
                  <div className="signUpModal-div3">
                    <span className="signUpModal-span4">Already have an account?
                      <a onClick={() => { setAddLoginAction(true); setAddSignUpAsAction(false); }} style={{ cursor: 'pointer', color: '#2544EE' }}>Login</a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </DialogContent>
      </Dialog>
      {
        employeeRole === "COACH"
          ?
          <Welcomecoachmodal
            role={employeeRole}
            open={open}
            setOpen={setOpen}
          />
          :
          <SignUp
            role={employeeRole}
            addSignUpAction={addSignUpAction}
            setAddSignUpAction={setAddSignUpAction}
          />
      }
      <LoginModal
        addLoginAction={addLoginAction}
        setAddLoginAction={setAddLoginAction}
      />
    </>
  );
}
